<template>
<div class="field-container tw-w-full">
  <span class="label">{{ field }}</span>
  <span>{{separator}}</span>
  <span class="value">
    <slot v-if="fieldType !== 'file'">{{ value }}</slot>
    <slot v-else name="file-viewer"></slot>
  </span>
  </div>
</template>
<script>
import { Component } from 'vue-property-decorator'
@Component({
  name: 'InfoBoxPanelField',
  props: {
    field: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: () => []
    },
    getIconComponent: {
      type: Function,
      default: () => null
    },
    getFileType: {
      type: Function,
      default: () => null
    },
    downloadFile: {
      type: Function,
      default: () => null
    },
    separator: {
      type: String,
      default: ': '
    }
  }
})

class InfoBoxPanelField extends Component {
  get fieldLabel () {
    return this.field
  }

  get fieldValue () {
    return this.value
  }
}
export default InfoBoxPanelField
</script>
<style scoped>
.field-container {
  margin-bottom: 0.75rem;
  color: #000;
  padding: 0.5rem;
  background-color:#f5f5f5;
  min-height: 2.5rem;
}

.label {
  color:#2b5479;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

</style>
